import React from 'react';
import Paper from '@mui/material/Paper';
import $ from 'jquery';
import uniqid from 'uniqid';
import Collapse from '@mui/material/Collapse';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import HelpIcon from '@mui/icons-material/Help';
import LinearProgress from '@mui/material/LinearProgress';
import AddAPhotoIcon from '@mui/icons-material/AddAPhoto';
import CancelIcon from '@mui/icons-material/Cancel';
import CloseIcon from '@mui/icons-material/Close';
import ActionDelete from '@mui/icons-material/Delete';
import grey from '@mui/material/colors/grey';

import {addFile, updateFileStatus, removeFile} from '../Actions'

const conf = {
  dateinameMaxLength:15,
}

const styles = {
  row: {
    display: 'flex',
    justifyContent: 'center',
  },
  imageInput: {
    display:'none',
  },
  docContainer: {
    display:"block",
    float:"left",
    width:"200px",
    marginRight:"20px",
    marginBottom:"20px",
    backgroundColor:grey[100],
  },
  filetypeAvatar: {
    marginTop:'15px',
    width:'60px',
    height:'auto',
  },
  center: {
    textAlign:'center',
  },
  clear: {
    clear:'left',
  },
  status: {
    height:'25px',
    paddingTop:'25px',
    paddingBottom:'0px',
    marginBottom:'0px',
    paddingRight:'8px',
    paddingLeft:'8px',
    textAlign:'center',
  },
  icons: {
    height:'50px',
    textAlign:'center',
  },
  dateinameTitel: {
    textAlign:'center',
    marginTop:'3px',
  },
  dateinameText: {
    height:'40px',
    paddingTop:'5px',
    textAlign:'center',
    fontSize:"120%",
  },
  dateinameInput: {
    height:'50px',
    marginTop:'-5px',
    textAlign:'center',
    paddingLeft:'20px',
    paddingRight:'20px',
  },
  extension: {
    color:grey[500],
  },
  helpBlock: {
    position:'relative',
  },
};

export default class FotosUploader extends React.Component {

  state = {
    showHilfeFotodokumentation: false,
  };

  prepareUpload = (event) => {
    let files = event.target.files

    Object.keys(files).map(
      (index) => files[index].uid = this.getNewDocId()
    )

    this.registerFiles(files)
    this.uploadFiles(files)
  }

  getNewDocId = () => {
    return uniqid.time()
  }

  uploadFiles = (files) => {
    var data = new FormData();
    $.each(files, function(key, value)
    {
        let id = value.uid
        data.append(key, value, id);
    })

    $.ajax({
        url: this.props.restPath+'dokumenteUpload.php?files',
        xhrFields: {
          withCredentials: true
        },
        type: 'POST',
        data: data,
        cache: false,
        dataType: 'json',
        context: this,
        processData: false, // Don't process the files
        contentType: false, // Set content type to false as jQuery will tell the server its a query string request
        success: function(data, textStatus, jqXHR)
        {
          this.updateStatus(data)
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
            // Handle errors here
            // STOP LOADING SPINNER
        }
    });
  }

  removeFile = (id) => {
    $.ajax({
        url: this.props.restPath+'dokumenteRemove.php?docId='+id,
        xhrFields: {
          withCredentials: true
        },
        type: 'POST',
        cache: false,
        dataType: 'json',
        processData: false,
        contentType: false,
        success: function(data, textStatus, jqXHR)
        {
            if( typeof data.error === 'undefined')
            {
            }
            else
            {
            }
        },
        error: function(jqXHR, textStatus, errorThrown)
        {
        }
    });
  }

  handleRemoveImg = (imgUid) => {
    this.props.dispatch(removeFile(this.props.lineage, imgUid))
    this.setState({files:{}})
    this.removeFile(imgUid)
  }

  registerFiles = (files) => {
    Object.keys(files).map(
      (index) => {
        var imageUid = files[index].uid
        var filename = files[index].name.split('.')
        var extension = filename.pop()
        var name = filename.join('.')
        if (!name) {
          name = "Unbenannt"
        }

        this.props.dispatch(
          addFile(
            this.props.lineage,
            name,
            extension,
            imageUid,
            'upload',
          )
        )
      }
    )
  }

  updateStatus = (report) => {
    report.map(
      (obj) => {
        let status = 'error'
        if (obj.status == 'success') {
          status = 'ok'
        }
        this.props.dispatch(
          updateFileStatus(
            this.props.lineage,
            obj.id,
            status,
          )
        )
      }
    )
  }

  renderImages = (id, statusCode) => {
    return (
      <Paper
        key={"docs_"+id}
        style={styles.docContainer}
      >
        {statusCode == 'upload' &&
        <div style={styles.status}>
           <LinearProgress mode="indeterminate" />
        </div>
        }

        {statusCode == 'ok' &&
        <div>
          <div style={styles.center}>
            <img
              style={styles.filetypeAvatar}
              src={this.props.restPath+"showImage.php?id="+id}
            />
          </div>

          <div style={styles.icons}>
            <IconButton sx={{ '& .MuiSvgIcon-root': { fontSize: 28 }}}
              tooltip="Löschen"
              onClick={() => this.handleRemoveImg(id)}
            >
              <ActionDelete />
            </IconButton>

          </div>
        </div>
        }

      </Paper>
    )
  }

  readDocs = () => {
    var arr = []
    Object.keys(this.props.fotos).map(
      (key) => {
        arr.push(
          this.renderImages(
            this.props.fotos[key].id,
            this.props.fotos[key].statusCode
          )
        )
      }
    )

    return arr
  }

  render(){
    return(
      <div>

        { this.readDocs() }

        <div style={styles.clear}></div>
          <input
             type="file"
             style={styles.imageInput}
             id={"imgFileSelect"+this.props.lineage.join('-')}
             name={"imgFileSelect"+this.props.lineage.join('-')}
             onChange={this.prepareUpload}
             accept={
               '.jpg, image/jpg'+
               ', .jpeg, image/jpeg'+
               ', .png, image/png'
             }
             multiple
          />

          <label htmlFor={"imgFileSelect"+this.props.lineage.join('-')}>
            <Button
               component="span"
               color="primary"
            >
              <AddAPhotoIcon /> &nbsp;Bilder zur Fotodokumentation hinzufügen
            </Button>
          </label>
          <Button
            component="span"
            color="primary"
            onClick={()=>this.setState({showHilfeFotodokumentation:!this.state.showHilfeFotodokumentation})}
          >
            {this.state.showHilfeFotodokumentation &&
              <CancelIcon />
            }
            {!this.state.showHilfeFotodokumentation &&
              <HelpIcon />
            }
            &nbsp;Hilfe zur Fotodokumentation
          </Button>
          <Collapse in={this.state.showHilfeFotodokumentation}>
            <Paper style={{marginTop:"10px", paddingBottom:"10px",}}>
              {this.props.hilfe}
              <div style={{textAlign:"center"}}>
                <Button
                  component="span"
                  color="primary"
                  onClick={()=>this.setState({showHilfeFotodokumentation:!this.state.showHilfeFotodokumentation})}
                >
                  <CloseIcon /> &nbsp;Hilfe Schließen
                </Button>
              </div>
            </Paper>
          </Collapse>
      </div>
    );
  }
}

